import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as appDialogSelectors from '../../selectors/appDialogSelectors';
import * as appDialogConstants from '../../constants/appDialog';

import ChangeUserRoleInOrganization from './ChangeUserRoleInOrganization';
import ChangeUserRoleInBucket from './ChangeUserRoleInBucket';
import RemoveUserFromOrganization from './RemoveUserFromOrganization';
import RemoveUserFromBucket from './RemoveUserFromBucket';
import AddUserToBuckets from './AddUserToOrganizationBuckets';

class AppDialog extends React.Component {
    render() {
        const { action, users, isOpen, closeDialog } = this.props;
        if (!isOpen) {
            return null;
        }

        switch (action) {
            case appDialogConstants.CHANGE_ROLE_IN_ORGANIZATION:
                return (
                    <ChangeUserRoleInOrganization
                        isOpen={isOpen}
                        closeDialog={closeDialog}
                        users={users}
                    />
                );
            case appDialogConstants.REMOVE_USER_FROM_ORGANIZATION:
                return (
                    <RemoveUserFromOrganization
                        isOpen={isOpen}
                        closeDialog={closeDialog}
                        users={users}
                    />
                );
            case appDialogConstants.CHANGE_ROLE_IN_BUCKET:
                return (
                    <ChangeUserRoleInBucket
                        isOpen={isOpen}
                        closeDialog={closeDialog}
                        users={users}
                    />
                );
            case appDialogConstants.ADD_USERS_TO_BUCKETS:
                return (
                    <AddUserToBuckets
                        isOpen={isOpen}
                        closeDialog={closeDialog}
                        users={users}
                    />
                );
            case appDialogConstants.REMOVE_USER_FROM_BUCKET:
                return (
                    <RemoveUserFromBucket
                        isOpen={isOpen}
                        closeDialog={closeDialog}
                        users={users}
                    />
                );
            default:
                return <div />;
        }
    }
}

AppDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeDialog: PropTypes.func.isRequired,
    action: PropTypes.string,
    users: PropTypes.array,
};

AppDialog.defaultProps = {
    action: undefined,
    users: [],
};

const mapDispatchToProps = dispatch => ({
    closeDialog: () =>
        dispatch({
            type: appDialogConstants.CLOSE_ACTION_DIALOG,
        }),
});

const mapStateToProps = state => {
    return {
        isOpen: appDialogSelectors.isAppDialogOpen(state),
        action: appDialogSelectors.getDialogAction(state),
        users: appDialogSelectors.getUsers(state),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AppDialog);



// WEBPACK FOOTER //
// ./src/containers/appDialog/AppDialog.js